import { useState } from 'react';
import { Heading, Accordion } from '@lululemon/b2b-ecom-pattern-library';
import cs from 'classnames';
import { ExpandedAccordionPanels } from 'shared/types/ecom-pattern-library';
import { CUSTOMER_SUPPORT } from 'helpers/utils/googleAnalyticsEvents';
import { useAnalytics } from 'hooks/useAnalytics';
import styles from './faq.module.scss';

type FaqAccordionProps = {
  accordionHeading: string;
  accordionContent: string;
};

export type FaqProps = {
  faqHeading: string;
  faqSubheading: string;
  faqAccordionItems: FaqAccordionProps[];
};

const FAQ = ({ faqHeading, faqSubheading, faqAccordionItems }: FaqProps) => {
  const { trackEvent, EVENT_CATEGORY } = useAnalytics();

  const accordionStates = () => {
    const states: ExpandedAccordionPanels = {};
    faqAccordionItems.forEach((_, index) => {
      states[index] = false;
    });

    return states;
  };

  const [expandedAccordionPanels, setExpandedAccordionPanels] = useState<ExpandedAccordionPanels>(accordionStates());

  const items = faqAccordionItems.map(({ accordionHeading, accordionContent }, index) => ({
    heading: accordionHeading,
    content: accordionContent,
    isOpen: expandedAccordionPanels[index],
    onClick: () => {
      setExpandedAccordionPanels((prevState) => {
        const newState = { ...prevState, [index]: !prevState[index] };
        trackEvent(EVENT_CATEGORY.COMPONENT_EVENT, CUSTOMER_SUPPORT.FAQ_ACCORDION_CLICKED(accordionHeading));
        return newState;
      });
    },
  }));

  return (
    <div data-testid="customer-support__faq_test-id" className={cs('lll-grid lll-grid-padding', styles.container)}>
      <Heading
        data-testid="customer-support__faq-heading_test-id"
        wrapperClassName={styles.heading}
        className="lll-type-heading-extra-large"
        tag="h1"
      >
        {faqHeading}
      </Heading>
      <div data-testid="customer-support__faq-subheading_test-id" className={styles.subheading}>
        {faqSubheading}
      </div>
      <div data-testid="customer-support__faq-accordion_test-id" className={styles.accordionContainer}>
        <Accordion id="faq-accordion" items={items} />
      </div>
    </div>
  );
};

export default FAQ;
